import React from 'react';
import {addMinutes, format} from 'date-fns';
import {usePersistentStore} from 'stores';

interface ICartPreorderDateProps {}

const CartPreorderDate = ({}: ICartPreorderDateProps) => {
  const preorderDate = usePersistentStore(s => s.preorderDate);
  if (!preorderDate) {
    return null;
  }
  return (
    <div className="pt-4 flex justify-center bg-white">
      <p className="rounded-full bg-green-500 inline-block text-center text-white font-medium px-5 py-1">
        READY AT {format(new Date(preorderDate), '(E) dd MMM, h:mm')} - {format(addMinutes(new Date(preorderDate), 30), 'h:mm a')}
      </p>
    </div>
  );
};

export default CartPreorderDate;
